import { render, staticRenderFns } from "./CompletedPage.vue?vue&type=template&id=1e0dc1a0&scoped=true&"
import script from "./CompletedPage.vue?vue&type=script&lang=ts&"
export * from "./CompletedPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0dc1a0",
  null
  
)

export default component.exports